{
    "PasswordChange_Title": "Alterar a palavra-passe",
    "PasswordChange_SubTitle": "Introduza a sua palavra-passe atual, a nova palavra-passe pretendida (é necessário um mínimo de {} caracteres), bem como a nova palavra-passe para confirmar o seu novo valor.",
    "PasswordChange_Fields_OldPassword": "Palavra-passe atual",
    "PasswordChange_Fields_NewPassword": "Nova palavra-passe",
    "PasswordChange_Fields_ConfirmPassword": "Confirmar a nova palavra-passe",
    "PasswordChange_Validations_PasswordsMustMatch": "As palavras-passe não coincidem",
    "PasswordChange_Validations_CurrentRequired": "É necessária uma palavra-passe atual",
    "PasswordChange_Validations_NewRequired": "É necessária uma nova palavra-passe",
    "PasswordChange_Validations_ConfirmRequired": "Confirmar palavra-passe necessária",
    "PasswordChange_Actions_ChangePassword": "Alterar a palavra-passe",
    "PasswordChange_Actions_Cancel": "Cancelar",
    "NAME": "PasswordChangeLanguage",
    "PasswordReset_Title": "Redefinição de senha",
    "PasswordReset_SubTitle": "Digite a nova senha desejada (mínimo de {} caracteres necessários), bem como a nova senha novamente para confirmar o novo valor.",
    "PasswordReset_Success": "Você atualizou com sucesso a senha da sua conta de usuário. \n \n Clique no botão **Continuar** que o levará de volta à página principal de boas-vindas, onde você também poderá clicar no link \"Fazer login\" para acessar sua conta.",
    "PasswordChange_Actions_Continue": "Continuar"
}